import { useEffect, useRef, useState } from "react";
import bolla_fetch from "../fetch/bolla_fetch";
import CampiBolla from "./CampiBolla";
import QuestionModal from "../riutilizabili/QuestionModal";
import { daEuCent } from "../riutilizabili/daEurCent";
import ConfermaCreazione from "../riutilizabili/ConfermaCreazione";
import { format } from "date-fns";
import funzioniRiccorrenti from "../riutilizabili/funzioniRiccorrenti";
import Attendere from "../riutilizabili/Attendere";


export default function CreaBollaEntrataDaUscita({
    bollaUscitaId ,
    iconaButtom ,
    classButtom
}) {
    const [ inputs , setInputs ] = useState({});
    const [viewCrea , setViewCrea] = useState(false);
    const [errors , setErrors] = useState({});
    const [campiObSegnale , setCampiObSegnale] = useState({
            'dataFattura': 'campo obbligatorio',
            'magazzinoId': 'campo obbligatorio',
            'fornitoreId': 'campo obbligatorio'
    });
    const [statoAvanti , setStatoAvanti] = useState(false);
    const [viewCreaAllert , setViewCreaAllert] = useState(false);
    const [viewAttendere , setViewAttendere] = useState(false);
    // Guardia anti doppio invio (ref, non state: setState e' asincrono e non fermerebbe
    // un secondo click immediato su CONFERMA). Senza questa, due click creavano due bolle.
    const invioInCorso = useRef(false);

    const campiOb = [
        'dataFattura',
        'fornitoreId',
        'magazzinoId' 
    ]

    const [magazzinoStop , setMagazzinoStop] = useState(false)

    useEffect(()=> {
        abilitaAvanti()
    },[inputs])

    const abilitaAvanti = () => {
       //console.log(campiOb , inputs);
        let error = funzioniRiccorrenti.validazioneCampi(campiOb , inputs);
       //console.log(error);
        if (Object.keys(error).length > 0) {
            setCampiObSegnale(error)
            setStatoAvanti(false)
        }else {
            setCampiObSegnale({})
            setStatoAvanti(true)
        }
    }

    const generaCodici= (prodotti) => {
        let codice = {}
        if (prodotti && prodotti.length > 0) {
            prodotti.forEach(element => {
                if (element.ProdSerialis) {
                    element.ProdSerialis.forEach((cod, key) => {
                        if (cod?.seriale) {
                            codice[cod.prodSezioneId + 'S' + parseInt(key)] = cod.seriale;
                        }
                        if (cod?.provisioning) {
                            codice[cod.prodSezioneId + 'P' + parseInt(key)] = cod.provisioning;
                        }
                    });
                }
            });
        }
        return codice
    }

    const readBollaUscita = async ()=> {
        // prods DEVE essere locale alla funzione: se sta a livello di componente ed e'
        // condiviso, due click ravvicinati sul pulsante (prima che la getBollaUscita
        // ritorni) fanno partire readBollaUscita due volte sullo STESSO array -> entrambe
        // fanno push -> il prodotto finisce due volte in inputs.prods -> con un solo
        // salvataggio la riga in prod_posizione_sezione viene RADDOPPIATA.
        const prods = []
        const bollaUscita = await bolla_fetch.getBollaUscita({id : bollaUscitaId})
       //console.log(bollaUscita.data[0] , ' bollaUscita');

        for (let index = 0; index < bollaUscita.data[0].prods.length; index++) {
            const prod = bollaUscita.data[0].prods[index];
            let prodTmp = { ...prod, id: null ,bollaUscitaId: null , bollaUscitaAnnoId : null }
            prodTmp.ProdSerialis = prod.ProdSerialis.map((seriale) => {
                return {
                    ...seriale,
                    id: null,
                    bollaUscitaId: null,
                    bollaUscitaAnnoId: null,
                    prodSezioneId: prod.prodottoId
                }
            }
            )

           //console.log(prodTmp.ProdSerialis ,' prodTmp.ProdSerialis');
            
            prods.push(prodTmp)
        }
        
        let codici = generaCodici(prods)
       //console.log(codici , ' codici');
        let prodSeriali = {}
        for (let index = 0; index < prods.length; index++) {
            const item = prods[index];
            prodSeriali['P'+item.prodottoId] =[];
        }

        console.log(bollaUscita.data[0] , ' bollaUscita.data[0]');
        

        const item = bollaUscita.data[0].mittente
        let an = {}
        an['anNominazioneCliente'] = item.viewName
        an['fornitoreId'] = item.mittenteId
        Object.keys(item).forEach(element => {
            ////console.log('an'+element.charAt(0).toUpperCase() + element.slice(1));
            an['an'+element.charAt(0).toUpperCase() + element.slice(1)] =item[element]
        });
        setMagazzinoStop(bollaUscita.data[0].magazzinoId)

        if (bollaUscita.data[0].magazzinoId !== 1) {
            an.magazzinoId = 1;
            an.magazzinoNome = "Magazzino Centrale Ancona";
        }
        
        setInputs({
            dataFattura : format(new Date(), 'yyyy-MM-dd') , 
            prodSeriali ,
            magazzinoId : 1,
            magazzinoNome : "Magazzino Centrale Ancona",
            ...bollaUscita.data[0] , 
            numero :bollaUscita.data[0].idProg+'/'+bollaUscita.data[0].annoId+(bollaUscita.data[0].codiceMag ? ' - '+ bollaUscita.data[0].codiceMag : '') , 
            prods , 
            id : null,
            anNominazioneFornitore : bollaUscita.data[0].mittente.viewName,
            ...an,
            dataOraPartenza : format(new Date(), "yyyy-MM-dd'T'HH:mm")
        })
        setViewCrea(true)
        abilitaAvanti()
    }

    const onChangeValue= (nome , valore) => {
       //console.log(nome);
        if ( nome.slice(-4) === 'Cent') {
            const cent = daEuCent(valore)
            setInputs(values => ({ ...values, [nome]: cent }))
            setInputs(values => ({ ...values, [nome.slice(0,nome.length-4)+'Eur']: valore }))
        } else {
           
            setInputs(values => ({ ...values, [nome]: valore }))
        }
    }  

    const onChangeViewCreaBolla = (stato) => {
        if (!!stato) {
            setViewCreaAllert(true)
        } else {
            setViewCreaAllert(false)
            setViewCrea(false)
        }
    }

    const onChangeCreaBolla = async(stato) => {
        if (!!stato) {
            if (invioInCorso.current) return   // salvataggio gia' in corso: ignora i click successivi
            invioInCorso.current = true
            setViewAttendere(true)
            setViewCreaAllert(false)
            setViewCrea(false)
            try {
                const bolla = await bolla_fetch.creaBollaEntrata(inputs);
                if (bolla.status === 200) {
                    setInputs({
                        dataFattura : format(new Date(), 'yyyy-MM-dd'),
                        dataOraPartenza :format(new Date(), "yyyy-MM-dd'T'HH:mm"),
                        magazzinoId : 1,
                        magazzinoNome : "Magazzino Centrale Ancona"
                    })
                    setErrors({})
                }
            } catch (error) {
                setErrors(error?.response?.data)
            } finally {
                invioInCorso.current = false
            }
            setViewAttendere(false)
           ////console.log(bolla , ' bolla creata');
        } else {
            setViewCrea(false)
            setErrors({})  
            setInputs({
                dataFattura : format(new Date(), 'yyyy-MM-dd'),
                dataOraPartenza :format(new Date(), "yyyy-MM-dd'T'HH:mm"),
                magazzinoId : 1,
                magazzinoNome : "Magazzino Centrale Ancona",
                prodSeriali :{}
            })  
        }
        setViewCreaAllert(false)
    }
   console.log(inputs , 'inputs');
    
    return(
        <>
            <button className={classButtom} onClick={readBollaUscita} >
                {iconaButtom}
            </button>

            {viewCrea &&<QuestionModal
                title={<div className="ms-4" >Crea ddt in entrata </div>}
                text={
                    <CampiBolla
                        entrata={true}
                        inputs={inputs} 
                        errors={{...errors , ...campiObSegnale}}
                        onChange={onChangeValue}
                        magazzinoStop={magazzinoStop}
                        />
                   }
                YesLabel='Salva'
                yesDisabled={!statoAvanti}
                onClose={onChangeViewCreaBolla}
                classi=' modal-xxl '
            />}

            <ConfermaCreazione
                label={'ATTENZIONE!!! OPERAZIONE IRREVERSIBILE'}
                testo={'stai prelevando i seguenti prodotti dal magazzino '+ inputs?.magazzinoNome + ' ?'}
                conferma={onChangeCreaBolla}
                stato={viewCreaAllert}
            />
            { !!viewAttendere && <Attendere />}
        </>
    )
}